import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditosService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-creacondicion',
  templateUrl: './creacondicion.component.html',
  styles: []
})
export class CreaCondicionComponent implements OnInit {

  forma: FormGroup;
  ido: string;
  service: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    public router: Router
  ) { }


  ngOnInit() {
    this.forma = new FormGroup({
      Key: new FormControl( null , Validators.required ),
      Descripcion: new FormControl( null , Validators.required )

    } );
  }


  CreaCondicion() {

    // Obtener el elemento por el id
    const Key: any = document.getElementById('Key');
    const Descripcion: any = document.getElementById('Descripcion');
    const Valor: any = document.getElementById('Valor');
    const Tcondicion: any = document.getElementById('Tcondicion');
    const Tlimitecredito: any = document.getElementById('Tlimitecredito');
    // Obtener el valor de la opción seleccionada

    const valorKey = Key.value;
    const valorDescripcion = Descripcion.value;
    const valorValor = Valor.value;
    const valorTcondicion = Tcondicion.value;
    const valorTlimitecredito = Tlimitecredito.value

    const params = {
      key: valorKey,
      description: valorDescripcion,
      value: valorValor,
      term_type: valorTcondicion,
      credit_limit: valorTlimitecredito,
      secret_key: '',
      token: ''
    }

    this.creditosService.crearCondicion( params ).subscribe( () => {
    Swal.fire({
      title: 'Creacion de condicion exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/panelcontrol/condiciones']);
      }

    } );

  }, (err) => {            // console.clear();
    // console.log(err);
                            Swal.fire(
                              'Ocurrio un error',
                              'Error',
                              'error'
                           );
                        } );

  }


}
